import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import '../styles/Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <Container>
        <Row>
          <Col md={6} className="mb-4 mb-md-0">
            <h5>About PAN Card Resizer</h5>
            <p>
              Your trusted resource for PAN card document resizing and digital document management. 
              Learn best practices for preparing your documents.
            </p>
          </Col>
          <Col md={6}>
            <h5>Quick Links</h5>
            <ul className="footer-links">
              <li>
                  PAN Card Resizer Tool
                
              </li>
              <li>
                  Resize Your Documents
              </li>
              <li>
                  Online Tools
               
              </li>
            </ul>
          </Col>
        </Row>
        <Row className="border-top border-secondary mt-4 pt-4">
          <Col className="text-center">
            <p className="mb-0">
              &copy; 2024 PAN Card Resizer Hub.
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}

export default Footer;
